<template>
  <div class="message" @click="hidemessage">
    <div class="messagecon">{{message}}<div class="surebutton">确定</div></div>
  </div>
</template>
<script>
  export default {
    props: [
      'message'
    ],
    methods: {
      hidemessage() {
        this.$emit("hidemessage")
      }
    }
  }
</script>
<style scoped>
  .message {
    position: fixed;
    left: 0;
    right: 0;
    top:0;
    bottom: 0;
    background: rgba(0,0,0,.7);
  }
  .messagecon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 68vw;
    background: none;
    line-height: 18vw;
    text-align: center;
    font-size: 3.5vw;
    background: #fff;
    padding: 5vw;
    color: #3f3f3f;
    border-radius: 1vw;
  }
  .messagecon img {
    vertical-align: middle;
    width: 5vw;
    margin-right: 2vw;
  }
  .surebutton {
    color: #fff;
    background: #fda635;
    height: 11vw;
    line-height: 11vw;
    border-radius: 1vw;
    width: 30vw;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/messagedhjr.vue